import { unref as _unref, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ddee7e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "menu-panel" }
const _hoisted_2 = { class: "popup-main" }
const _hoisted_3 = { class: "popup-header" }
const _hoisted_4 = { class: "popup-content" }
const _hoisted_5 = { class: "game-menu-list" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "menu-name" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider-line" }, null, -1))
const _hoisted_9 = { class: "menu-list" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "menu-name" }
const _hoisted_12 = {
  key: 0,
  class: "badge-wrap"
}
const _hoisted_13 = {
  key: 1,
  class: "badge-wrap"
}
const _hoisted_14 = {
  key: 2,
  class: "badge-wrap"
}
const _hoisted_15 = { class: "popup-footer" }
const _hoisted_16 = { class: "follow-wrap" }
const _hoisted_17 = { class: "flex justify-center" }
const _hoisted_18 = { class: "follow-label" }

import { ref, reactive, onMounted, onUnmounted } from 'vue';
import { useRouter } from 'vue-router'
import { storeToRefs } from 'pinia';
import { useHelpTool, usePWA } from '@/hooks';
import { useUserStore, useAccountStore, useGameStore, usePopupStore, useReddotStore } from "@/store";
import ThemeSwitch from '@/components/ThemeSwitch';


export default {
  __name: 'MenuPanel',
  props: ['show'],
  emits: ['onClose'],
  setup(__props, { emit: __emit }) {



const emit = __emit

const router = useRouter()
const { checkUserLogin, imageByTheme } = useHelpTool()
const { installPWA } = usePWA();

const userStore = useUserStore();
const { uid } = storeToRefs(userStore);
const accountStore = useAccountStore();
const { point } = storeToRefs(accountStore);
const gameStore = useGameStore();
const { gameMenu, activeGameMenu } = storeToRefs(gameStore);
const popupStore = usePopupStore();
const redDotStore = useReddotStore();
const { loginBonusRewardNum, inviteFriendToEarnNum, inboxUnread, taskRewardNum } = storeToRefs(redDotStore);

const menuList = reactive([
  { code: 'records',  pathName: 'records' },
  { code: 'gameRecords',  pathName: 'gameRecord' },
  { code: 'chat',  pathName: 'livechat' },
  // { code: 'vip',  pathName: 'vip' },
  // { code: 'security',  pathName: 'securityCenter' },
  { code: 'settings',  pathName: 'setting' },
  // { code: 'inbox',  pathName: 'inbox' },
  { code: 'redeem',  pathName: 'redeem' },
  // { code: 'signUpBonus',  pathName: 'signUp' },
  { code: 'promotions',  pathName: 'promotion' },
  // { code: 'task',  pathName: 'task' },
  { code: 'follow',  onClick: () => showFollowPopup() },
]);

const socialMediaList = ref(['facebook', 'telegram']);

const clickGameMenu = item => {
  if (router.currentRoute.value.name === 'game') {
    gameStore.changeMenu(item);
    emit('onClose');
  } else {
    router.push({ name: 'game' })
  }
} 

const clickMenu = item => {
  if(item.onClick) {
    item.onClick()
  } else {
    router.push({ name: item.pathName })
  }
}

const showFollowPopup = () => {
  checkUserLogin(() => {
    emit('onClose');
    popupStore.set('showFollow');
  })
}

return (_ctx, _cache) => {
  const _component_van_image = _resolveComponent("van-image")
  const _component_van_popup = _resolveComponent("van-popup")
  const _directive_audio = _resolveDirective("audio")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_popup, {
      show: __props.show,
      position: "left",
      "close-on-click-overlay": false,
      onClickOverlay: _cache[1] || (_cache[1] = $event => (emit('onClose')))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _withDirectives(_createVNode(_component_van_image, {
              class: "popup-title",
              src: _unref(imageByTheme)('logo.png'),
              onClick: _cache[0] || (_cache[0] = $event => (_ctx.$router.push({ name: 'game' })))
            }, null, 8, ["src"]), [
              [_directive_audio]
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            (_unref(gameMenu) && _unref(gameMenu).length > 0)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(gameMenu), (item) => {
                      return _withDirectives((_openBlock(), _createElementBlock("div", {
                        class: _normalizeClass(`menu-item ${ _unref(router).currentRoute.value.name === 'game' && _unref(activeGameMenu) && _unref(activeGameMenu).code === item.code ? 'active' : 'inactive'}`),
                        key: item.code,
                        onClick: $event => (clickGameMenu(item))
                      }, [
                        _createVNode(_component_van_image, {
                          class: "menu-icon",
                          fit: "contain",
                          src: require(`@/assets/img/common/menu/${item.code}.png`)
                        }, null, 8, ["src"]),
                        _createElementVNode("div", _hoisted_7, _toDisplayString(item.name), 1)
                      ], 10, _hoisted_6)), [
                        [_directive_audio]
                      ])
                    }), 128))
                  ]),
                  _hoisted_8
                ], 64))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuList, (item) => {
                return _withDirectives((_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(`menu-item ${_ctx.$route.name === item.pathName ? 'active' : 'inactive'}`),
                  key: item.code,
                  onClick: $event => (clickMenu(item))
                }, [
                  _createVNode(_component_van_image, {
                    class: "menu-icon",
                    fit: "contain",
                    src: require(`@/assets/img/common/menu/${item.code}.png`)
                  }, null, 8, ["src"]),
                  _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t(`menu.${item.code}`).toUpperCase()), 1),
                  (item.code === 'inbox' && _unref(inboxUnread))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_unref(inboxUnread)), 1))
                    : (item.code === 'signUpBonus' && _unref(loginBonusRewardNum))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_unref(loginBonusRewardNum)), 1))
                      : (item.code === 'task' && _unref(taskRewardNum))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_unref(taskRewardNum)), 1))
                        : _createCommentVNode("", true)
                ], 10, _hoisted_10)), [
                  [_directive_audio]
                ])
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_unref(ThemeSwitch)),
            _withDirectives(_createVNode(_component_van_image, {
              class: "app-logo",
              src: _unref(imageByTheme)('logo.png'),
              onClick: _unref(installPWA)
            }, null, 8, ["src", "onClick"]), [
              [_directive_audio]
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(socialMediaList.value, (item) => {
                  return (_openBlock(), _createBlock(_component_van_image, {
                    class: "social-media-icon",
                    fit: "contain",
                    src: require(`@/assets/img/common/socialMedia/icon/${item}.png`)
                  }, null, 8, ["src"]))
                }), 256))
              ]),
              _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('socialMedia.followShare')), 1)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

}